<template>
  <div class="tab">
    <el-footer v-if="$can('create', 'cameras_recipients')" class="tab__footer page__active_bar">
      <el-button class="page__active_button" type="primary" @click="addDialog = true">
        Добавить камеру <i class="el-icon-plus" />
      </el-button>
    </el-footer>
    <main class="page_container">
      <el-table v-loading="loading" class="list" :data="sharedCameras" :default-sort="{ prop: 'client_name_master', order: 'ascending' }">
        <el-table-column prop="short_name" label="Камера" sortable :sort-orders="['ascending', 'descending']">
          <template slot-scope="scope">
            <router-link class="link" :to="{ name: 'cameras:edit', params: { id: scope.row.id_camera } }">
              {{ scope.row.short_name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="client_name_master" label="Владелец" sortable :sort-orders="['ascending', 'descending']">
          <template slot-scope="scope">
            <router-link class="link" :to="'/client/edit/' + scope.row.id_account_master">
              {{ scope.row.client_name_master }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="Адрес" sortable :sort-orders="['ascending', 'descending']" />
        <el-table-column prop="ip" label="ip" sortable :sort-orders="['ascending', 'descending']" />
        <el-table-column prop="enabled" label="Все уведомления">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.enabled)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_about_detection" label="Детекция">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_about_detection)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_about_intercom_calls" label="Домофон">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_about_intercom_calls)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_about_monitoring" label="Мониторинг">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_about_monitoring)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_by_push" label="Пуш">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_by_push)" />
          </template>
        </el-table-column>
        <el-table-column prop="notify_by_telegram" label="Телеграм">
          <template slot-scope="scope">
            <el-checkbox :value="Boolean(scope.row.notify_by_telegram)" />
          </template>
        </el-table-column>
      </el-table>
    </main>
    <client-recipient-dialog
      :client-id="clientId"
      :visible.sync="addDialog"
      @added="updateCamerasList"
      @closed="addDialog = false"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ClientRecipientDialog from "@/components/Client/components/features/ClientRecipientDialog";

export default {
  name: "ClientSharedCamerasTab",
  components: { ClientRecipientDialog },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      addDialog: false,
    };
  },
  computed: {
    ...mapState("client", ["sharedCameras"]),
  },
  watch: {
    clientId: {
      immediate: true,
      handler() {
        this.updateCamerasList();
      },
    },
  },
  methods: {
    ...mapActions("client", {
      getSharedCameras: "GET_CLIENT_SHARED_CAMERAS",
    }),
    updateCamerasList() {
      this.loading = true;
      this.getSharedCameras(this.clientId).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
